/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  THideOfferWebsiteModel,
  IHideOfferWebsiteRequest,
  IMappers,
  IHideOfferWebsiteResponse,
  IHideOfferWebsiteResponseError,
  THideOfferWebsiteResponse,
} from './types';

const defaultConfig: THideOfferWebsiteModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'hidden-objects',
  pathApi: '/v1/hide-offer-website/',
  hostType: 'api',
} as THideOfferWebsiteModel;

function createHideOfferWebsiteModel(parameters: IHideOfferWebsiteRequest): THideOfferWebsiteModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IHideOfferWebsiteOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IHideOfferWebsiteRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchHideOfferWebsite<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IHideOfferWebsiteOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | THideOfferWebsiteResponse
> {
  const { response, statusCode } = await httpApi.fetch(createHideOfferWebsiteModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IHideOfferWebsiteResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IHideOfferWebsiteResponseError);
    }
  }

  return { response, statusCode } as THideOfferWebsiteResponse;
}

export { defaultConfig, createHideOfferWebsiteModel, fetchHideOfferWebsite };
